import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonItem, IonLabel, IonAvatar, IonBadge } from '@ionic/angular/standalone';
import { SessionMember, SessionRole, PresenceState } from '@crowdctrl/core';

@Component({
  selector: 'crowdctrl-session-member-item',
  standalone: true,
  imports: [CommonModule, RouterModule, IonItem, IonLabel, IonAvatar, IonBadge],
  templateUrl: './session-member-item.component.html',
  styleUrl: './session-member-item.component.css',
})
export class SessionMemberItemComponent {
  @Input() member!: SessionMember;
  @Input() isCurrentUser = false;
  @Input() disabled = false;
  @Input() button = false;
  @Input() detail = false;
  @Input() routerLink?: string[] | null;

  getRoleBadgeColor(role: SessionRole): string {
    // Consistent badge colors per role model spec
    switch (role) {
      case 'Coordinator':
        return 'primary'; // Coordinator role
      case 'Responder':
        return 'secondary'; // Responder role
      case 'Observer':
        return 'medium'; // Observer role
      default:
        return 'medium';
    }
  }

  getPresenceColor(presenceState?: PresenceState): string {
    switch (presenceState) {
      case 'active':
        return 'success';
      case 'away':
        return 'warning';
      case 'offline':
        return 'medium';
      default:
        return 'medium';
    }
  }

  getPresenceDisplayName(presenceState?: PresenceState): string {
    switch (presenceState) {
      case 'active':
        return 'Active';
      case 'away':
        return 'Away';
      case 'offline':
        return 'Offline';
      default:
        return 'Unknown';
    }
  }

  getMemberDisplayName(member: SessionMember): string {
    if (member.user) {
      return member.user.email || 'Unknown Member';
    }
    return 'Unknown Member';
  }
}
